import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileText, Database, Shield, CheckCircle } from 'lucide-react';
import SystemCheckCard, { SystemCheck } from './SystemCheckCard';

interface SystemChecksListProps {
  checks: SystemCheck[];
}

const SystemChecksList: React.FC<SystemChecksListProps> = ({ checks }) => {
  const getCategoryIcon = (category: string) => {
    switch (category) {
      case 'backend':
        return <Database className="h-4 w-4" />;
      case 'frontend':
        return <FileText className="h-4 w-4" />;
      case 'database':
        return <Database className="h-4 w-4" />;
      case 'security':
        return <Shield className="h-4 w-4" />;
      case 'ui':
        return <FileText className="h-4 w-4" />;
      default:
        return <CheckCircle className="h-4 w-4" />;
    }
  };

  const getCategoryDisplayName = (category: string) => {
    switch (category) {
      case 'backend':
        return 'Backend';
      case 'frontend':
        return 'Frontend';
      case 'database':
        return 'База данных';
      case 'security':
        return 'Безопасность';
      case 'ui':
        return 'Интерфейс';
      default:
        return category;
    }
  };

  const groupedChecks = checks.reduce((acc, check) => {
    if (!acc[check.category]) {
      acc[check.category] = [];
    }
    acc[check.category].push(check);
    return acc;
  }, {} as Record<string, SystemCheck[]>);

  return (
    <div className="space-y-6">
      {Object.entries(groupedChecks).map(([category, categoryChecks]) => (
        <Card key={category}>
          <CardHeader>
            <CardTitle className="flex items-center gap-2 capitalize">
              {getCategoryIcon(category)}
              {getCategoryDisplayName(category)}
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            {categoryChecks.map((check, index) => (
              <SystemCheckCard key={index} check={check} />
            ))}
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default SystemChecksList;
